import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';
import Layout from '../components/Layout/Layout';
import Hero from '../components/Screens/Hero';
import Main from '../components/Screens/Main';
import Section from '../components/Screens/Section';
import Link from '../components/Global/Link';
import CardGame from '../components/Cards/CardGame';

// ====

const OurGames = (props) => {
  const { data, blok } = props;
  let pageData;
  if (data) {
    pageData = JSON.parse(data.index.content);
  } else {
    pageData = blok;
  }
  const openGraph = {
    type: 'website',
    title: pageData.messaging,
    description: pageData.messaging,
    image: pageData.hero_image,
    meta_fb_pages: pageData.meta_fb_pages,
  };

  const [showAllGames, setShowAllGames] = useState(false);

  return (
    <Layout
      meta={pageData.meta}
      openGraph={openGraph}
      image={pageData.hero_image}
      background="red"
    >
      <Hero title={pageData.messaging} />
      <Main>
        <Section align="center">
          {blok ? (
            'Games dynamically loaded'
          ) : (
            <>
              {pageData.primary_games.map((meta) => {
                return (
                  <>
                    <CardGame
                      title={meta.game_title}
                      image={meta.game_cover}
                      link={`${meta.game_link.story.slug}`}
                      copy={meta.short_description}
                    />
                  </>
                );
              })}
            </>
          )}
        </Section>

        {!showAllGames && (
          <Section className="pt-3 pb-3" marginBottom>
            <Link
              button
              icon="chevron-down"
              onClick={() => setShowAllGames(!showAllGames)}
            >
              See more
            </Link>
          </Section>
        )}

        {showAllGames && (
          <Section marginBottom>
            {pageData.secondary_games.map((meta) => {
              return (
                <CardGame
                  mode="slim"
                  title={meta.game_title}
                  image={meta.game_cover}
                  copy={meta.short_description}
                  link={meta.game_link.cached_url}
                  animate="onReveal"
                />
              );
            })}
          </Section>
        )}
      </Main>
    </Layout>
  );
};

export default OurGames;

// ====

export const QUERY = graphql`
  query OurGamesDefaultQuery {
    index: storyblokEntry(slug: { eq: "our-games" }) {
      content
    }
  }
`;

OurGames.propTypes = {
  data: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  blok: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

OurGames.defaultProps = {
  data: null,
  blok: null,
};
